export default __webpack_public_path__ + "static/img_1-8274133abb8bd0e10217f3984e2e6d20.webp";